import {
	CheckCircle,
	CurrencyCircleDollar,
	DownloadSimple,
	Files,
	Flag,
} from '@phosphor-icons/react';
import { MonthlyDeclarationOverviewItem } from '../../../@types/TaxProfile';
import Modal from '../../molecules/Modal/Modal';
import { getFormatDate, getMonthName } from '../../../shared/utils/dates.util';
import {
	capitalizeFirstLetter,
	formatCurrency,
} from '../../../shared/utils/general.util';

const DownloadReceipt = ({ label, url }: { label: string; url: string }) => {
	const handleDownload = () => {
		window.open(url, '_blank');
	};
	if (!url) return null;
	return (
		<button
			onClick={handleDownload}
			className='min-h-14 bg-neutral-100 w-full p-3 rounded-lg flex items-center gap-2 justify-between text-neutral-600 hover:bg-neutral-200 transition-colors text-left text-sm md:text-base'
		>
			{label}
			<div>
				<DownloadSimple
					size={16}
					weight='bold'
				/>
			</div>
		</button>
	);
};

const ModalPresentedDeclaration = ({
	selectedPresentedDeclaration,
	setSelectedPresentedDeclaration,
}: {
	selectedPresentedDeclaration: MonthlyDeclarationOverviewItem | null;
	setSelectedPresentedDeclaration: (
		declaration: MonthlyDeclarationOverviewItem | null,
	) => void;
}) => {
	const title =
		selectedPresentedDeclaration?.type === 'annual'
			? `Declaración anual ${selectedPresentedDeclaration?.declaration_year}`
			: `${capitalizeFirstLetter(
					getMonthName(
						Number(
							selectedPresentedDeclaration?.declaration_period?.split('-')[0],
						),
					),
				)} ${selectedPresentedDeclaration?.declaration_period?.split('-')[1]}`;

	return (
		<Modal
			open={!!selectedPresentedDeclaration}
			onClose={() => setSelectedPresentedDeclaration(null)}
			sx='!p-4 w-[96%] max-w-xl max-h-[90dvh] overflow-y-auto'
		>
			<div className='flex flex-col gap-4 leading-tight'>
				<div>
					<p className='font-bold text-lg'>{title}</p>
					{selectedPresentedDeclaration?.presented_at && (
						<>
							{selectedPresentedDeclaration?.presented_by === 'Heru' ? (
								<p className='flex items-center gap-2 text-green-700 mt-1'>
									<CheckCircle
										size={16}
										weight='duotone'
									/>
									Presentada por heru el{' '}
									{getFormatDate(selectedPresentedDeclaration?.presented_at!)}
								</p>
							) : (
								<p className='flex items-center gap-2 text-green-700 mt-1'>
									Presentada el{' '}
									{getFormatDate(selectedPresentedDeclaration?.presented_at!)}
								</p>
							)}
						</>
					)}
				</div>
				<hr />

				<div className='flex flex-col gap-1'>
					<p className='flex items-center gap-2 font-light'>
						<Flag />
						{selectedPresentedDeclaration?.type
							? {
									platec: 'Plataformas tecnológicas',
									resico: 'RESICO',
									annual: 'Declaración anual',
								}[selectedPresentedDeclaration?.type]
							: 'Plataformas tecnológicas'}
					</p>
					{selectedPresentedDeclaration?.type !== 'annual' && (
						<p className='font-light flex items-center gap-2'>
							<Files
								weight='bold'
								className='text-gray-500'
								size={16}
							/>
							Declaración{' '}
							{selectedPresentedDeclaration?.declaration_type?.toLowerCase()}
						</p>
					)}
					<p className='font-light flex items-center gap-2'>
						<CurrencyCircleDollar
							weight='bold'
							className='text-gray-500'
							size={16}
						/>
						Resultado con {selectedPresentedDeclaration?.declaration_result}
					</p>
				</div>
				<hr />

				{selectedPresentedDeclaration?.identified_income! > 0 && (
					<>
						<div className='flex flex-col gap-1'>
							<p className='font-light flex items-center gap-2 justify-between'>
								Ingresos del mes:{' '}
								<span className='font-bold'>
									{formatCurrency(
										selectedPresentedDeclaration?.identified_income ?? 0,
									)}
								</span>
							</p>
						</div>
						<hr />
					</>
				)}

				<div className='flex flex-col md:flex-row gap-2'>
					<DownloadReceipt
						label='Acuse de pago'
						url={selectedPresentedDeclaration?.paid_pdf!}
					/>
					<DownloadReceipt
						label='Acuse de presentación'
						url={selectedPresentedDeclaration?.presentation_pdf!}
					/>
					<DownloadReceipt
						label='Detalle de declaración'
						url={selectedPresentedDeclaration?.detail_pdf!}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default ModalPresentedDeclaration;
